/* ============================================================
   PJ Scroll Animations — Targeted reveals (no auto-tagger)
   Applies classes to specific homepage sections via selectors.
   Observes them with IntersectionObserver once.
   ============================================================ */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* Each rule: { sel: css selector, type: 'fade-up' | 'fade-in' | 'scale-up' | 'stagger', delay?: number } */
  var RULES = [
    /* ---- Hero #1: text fade-up (Ken Burns is pure CSS) ---- */
    { sel: '.pj-hero-copy .pj-hero-small', type: 'fade-up', delay: 200 },
    { sel: '.pj-hero-copy .pj-hero-big',   type: 'fade-up', delay: 400 },

    /* ---- Story-Block ("WIR VERKAUFEN GESCHICHTE") ---- */
    { sel: '.pj-story__title', type: 'fade-up' },
    { sel: '.pj-story .pj-grid', type: 'stagger' },

    /* ---- Section yXq7Gt (generic): only headings inside ---- */
    { sel: '#shopify-section-section_yXq7Gt h1, #shopify-section-section_yXq7Gt h2, #shopify-section-section_yXq7Gt h3', type: 'fade-up' },

    /* ---- OUR STORY timeline ---- */
    { sel: '.pj-ourstory-head', type: 'fade-up' },
    { sel: '.pj-ourstory-track', type: 'stagger' },

    /* ---- Reviews ---- */
    { sel: '.pj-reviews__heading', type: 'fade-up' },
    { sel: '.pj-reviews__meta',    type: 'fade-up', delay: 100 },
    { sel: '.pj-reviews__subtext', type: 'fade-up', delay: 200 },
    { sel: '.pj-reviews__slider',  type: 'stagger' },

    /* ---- Homepage Rückgabe-FAQ (scoped: combo class, not the Buy-Box accordion) ---- */
    { sel: '.pj-accordion.pj-faq', type: 'stagger' },

    /* ---- PDP: Brand Story (since. 2003 → Damals / Heute / Wer dahintersteht) ---- */
    { sel: '.pj-brand-story__intro',    type: 'fade-up' },
    { sel: '.pj-brand-story__chapters', type: 'stagger' },

    /* ---- PDP: Reels headline only — cards stay native (horizontal scroll + clone loop) ---- */
    { sel: '.pj-reels__head', type: 'fade-up' },

    /* ---- PDP: FAQ (Häufige Fragen) ---- */
    { sel: '.pj-faq-title', type: 'fade-up' },
    { sel: '.pj-faq-list',  type: 'stagger' },

    /* ---- PDP: Trust strip ---- */
    { sel: '.pj-trust-strip', type: 'fade-up' },

    /* ---- PDP: Bundle ("MAKE IT A MATCH") ---- */
    { sel: '.pj-bundle-title', type: 'fade-up' },
    { sel: '.pj-bundle-sub',   type: 'fade-up', delay: 100 },
    { sel: '.pj-bundle-items', type: 'stagger' }
  ];

  function applyClass(el, type, delay) {
    if (!el || el.classList.contains('pj-anim-fade-up') || el.classList.contains('pj-anim-fade-in') || el.classList.contains('pj-anim-scale-up') || el.classList.contains('pj-stagger')) return;
    if (type === 'stagger') {
      el.classList.add('pj-stagger');
    } else {
      el.classList.add('pj-anim-' + type);
    }
    if (delay) el.setAttribute('data-pj-delay', String(delay));
  }

  function tagAll() {
    var tagged = [];
    RULES.forEach(function (rule) {
      var nodes = document.querySelectorAll(rule.sel);
      Array.prototype.forEach.call(nodes, function (el) {
        applyClass(el, rule.type, rule.delay);
        tagged.push(el);
      });
    });

    /* Hero #2: fade-in the section content (find 2nd shopify-section that contains hero media) */
    var sections = document.querySelectorAll('#MainContent > shopify-section');
    var heroIndex = 0;
    for (var i = 0; i < sections.length; i++) {
      var s = sections[i];
      if (s.querySelector('.hero__image, .hero__video')) {
        if (heroIndex === 1) {
          /* This is Hero #2 — fade-in its inner block container */
          var inner = s.querySelector('.section, .hero, .hero__inner, [class*="hero__"]') || s;
          applyClass(inner, 'fade-in');
          tagged.push(inner);
          break;
        }
        heroIndex++;
      }
    }

    /* Product list: target product-card children */
    var productSections = document.querySelectorAll('#MainContent > shopify-section [class*="product-list"], #MainContent > shopify-section [class*="resource-list"], #MainContent > shopify-section .product-grid');
    Array.prototype.forEach.call(productSections, function (grid) {
      if (grid.children.length >= 2) {
        applyClass(grid, 'stagger');
        tagged.push(grid);
      }
    });
    /* Fallback: if not found by class, look for any product-card group */
    if (!productSections.length) {
      var cards = document.querySelectorAll('#MainContent > shopify-section product-card, #MainContent > shopify-section .product-card');
      if (cards.length >= 2 && cards[0].parentElement) {
        var parent = cards[0].parentElement;
        applyClass(parent, 'stagger');
        tagged.push(parent);
      }
    }

    return tagged;
  }

  function observe(elements) {
    if (!('IntersectionObserver' in window) || !elements.length) {
      elements.forEach(function (el) { el.classList.add('pj-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('pj-in');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -5% 0px' });

    elements.forEach(function (el) { io.observe(el); });
  }

  function init() {
    var tagged = tagAll();
    observe(tagged);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-init on Shopify section reload in theme editor */
  document.addEventListener('shopify:section:load', function () {
    setTimeout(init, 50);
  });
})();
